import { FC, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Licenses } from 'types/Licenses';
import { getCurrentScene, setVideoContentFromTool } from 'modules/scenes';
import { UploadContent } from './PhotoSidebarTool';
import { useStockVideos } from './stockVideoTool/useStockVideos';
import { StockVideoToolBase } from './stockVideoTool/StockVideoToolBase';

export const StockVideosTool: FC = () => {
  const stockVideos = useStockVideos();
  const currentScene = useSelector(getCurrentScene);

  const dispatch = useDispatch();

  const selectVideo = useCallback(
    (id: string) => {
      if (currentScene) {
        const { url, license, id: videoId, source, bigResSrc } = stockVideos.videos.find(
          item => item.id === id
        );
        dispatch(
          setVideoContentFromTool(
            url,
            bigResSrc,
            license === 'fte' ? Licenses.StockVideoFree : license,
            currentScene.id,
            videoId,
            source
          )
        );
      }
    },
    [currentScene?.id, stockVideos.videos]
  );

  return (
    <div>
      <StockVideoToolBase {...stockVideos} selectVideo={selectVideo} />
      <UploadContent type="video" position="relative" />
    </div>
  );
};
